import { createApi } from '@reduxjs/toolkit/query/react';
import Partner from 'models/StakeholderMap/Partner';
import { axiosBaseQuery } from 'services/api';
import { byId } from 'store/utils/sortFunctions';

const PARTNER_TAG = 'Partner';

// API slice for Stakeholder Map / Partners
export const partnersApi = createApi({
  reducerPath: 'partnersApi',
  baseQuery: axiosBaseQuery({
    apiPath: '/api',
  }),
  tagTypes: [PARTNER_TAG],
  endpoints: builder => ({
    listPartners: builder.query({
      query: ({ project, product }) => ({
        url: `/projects/${project}/products/${product}/partners/`,
      }),
      transformResponse: response =>
        Array.isArray(response) ? response.map(partner => new Partner(partner)).sort(byId) : [],
      providesTags: [PARTNER_TAG],
    }),

    fetchPartner: builder.query({
      query: ({ project, product, partnerId }) => ({
        url: `/projects/${project}/products/${product}/partners/${partnerId}/`,
      }),
      transformResponse: response => new Partner(response),
      providesTags: [PARTNER_TAG],
    }),

    createPartner: builder.mutation({
      query: ({ project, product, ...partner }) => ({
        url: `/projects/${project}/products/${product}/partners/`,
        method: 'POST',
        data: {
          project,
          ...partner,
        },
      }),
      invalidatesTags: [PARTNER_TAG],
      transformResponse: response => new Partner(response),
    }),

    updatePartner: builder.mutation({
      query: ({ project, product, partnerId, ...partner }) => ({
        url: `/projects/${project}/products/${product}/partners/${partnerId}/`,
        method: 'PATCH',
        data: partner,
      }),
      invalidatesTags: [PARTNER_TAG],
      transformResponse: response => new Partner(response),
    }),

    deletePartner: builder.mutation({
      query: ({ project, product, partnerId }) => ({
        url: `/projects/${project}/products/${product}/partners/${partnerId}/`,
        method: 'DELETE',
      }),
      invalidatesTags: [PARTNER_TAG],
    }),
  }),
});

export const {
  useListPartnersQuery,
  useFetchPartnerQuery,
  useCreatePartnerMutation,
  useUpdatePartnerMutation,
  useDeletePartnerMutation,
} = partnersApi;
